import React from 'react';
import Heading from '@atlaskit/heading';
import { Flex, Text, xcss } from '@atlaskit/primitives';
var containerStyles = xcss({
  marginBlockStart: 'space.600',
  marginBlockEnd: 'space.600',
  textAlign: 'center'
});
export var EmptyState = function EmptyState(_ref) {
  var testId = _ref.testId,
    header = _ref.header,
    description = _ref.description,
    renderImage = _ref.renderImage;
  return /*#__PURE__*/React.createElement(Flex, {
    xcss: containerStyles,
    testId: testId,
    direction: "column",
    alignItems: "center",
    gap: "space.300"
  }, renderImage === null || renderImage === void 0 ? void 0 : renderImage(), /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    alignItems: "center",
    gap: "space.200"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "medium",
    as: "h2"
  }, header), description && /*#__PURE__*/React.createElement(Text, {
    as: "p",
    color: "color.text"
  }, description)));
};